import { Component, Input, OnInit } from '@angular/core';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
})
export class TimelineComponent implements OnInit {
  constructor(private utility: UtilityService) {}

  @Input() timelineData: any = [];

  dataToDisplay: any = [];

  spinner = true;

  ngOnInit(): void {
    this.filterData();
  }

  filterData() {
    if (this.timelineData.length) {
      this.timelineData = this.sortTimelineData(this.timelineData);
      this.timelineData.forEach((data: any, index: number) => {
        if (index === 0) {
          this.dataToDisplay.push({
            date: data.date,
            data: [
              {
                time: data.time,
                status: data.status,
                height: 0,
              },
            ],
          });
        } else {
          let existingDataIndex = this.dataToDisplay.findIndex(
            (existingData: any) => existingData.date === data.date
          );
          if (existingDataIndex !== -1) {
            this.dataToDisplay[existingDataIndex].data.push({
              time: data.time,
              status: data.status,
              height: 0,
            });
          } else {
            this.dataToDisplay.push({
              date: data.date,
              data: [
                {
                  time: data.time,
                  status: data.status,
                  height: 0,
                },
              ],
            });
          }
        }
      });
      this.dataToDisplay.forEach((timeline: any) => {
        timeline = this.calculateHeight(timeline);
      });
      this.spinner = false;
    } else {
      this.utility.alertWarning('No data found', '');
      this.spinner = false;
    }
  }

  sortTimelineData(timelineData: any) {
    if (timelineData.length) {
      return timelineData.sort((a: any, b: any) => {
        const aDate = new Date(`${a.date} ${a.time}`);
        const bDate = new Date(`${b.date} ${b.time}`);
        return bDate.getTime() - aDate.getTime();
      });
    } else {
      console.log('No data to sort');
    }
  }
  // used for making the chart into graph(quantative height calculation represents the time difference between two events in hours and the height of each hour is 20px)
  calculateHeight(timeline: any) {
    if (timeline) {
      timeline.data.forEach((data: any, index: number) => {
        if (index === 0) {
          data.height = 0;
        } else {
          const previousData = timeline.data[index - 1];
          const date = new Date();
          const currentTime = date.setHours(
            data.time.split(':')[0],
            data.time.split(':')[1]
          );
          const previousTime = date.setHours(
            previousData.time.split(':')[0],
            previousData.time.split(':')[1]
          );
          const hoursDifference =
            (previousTime - currentTime) / (1000 * 60 * 60);
          const heightPerHour = 20;
          data.height = hoursDifference * heightPerHour;
        }
      });

      return timeline;
    }
  }
}
